import comRichtext from '../../components/com-richtext.vue';
export default{
    name:'HomeDetail',
    data(){
        return{
            detail:{},
            breadTitle:'',
            breadTo:{},
        }
    },
    created(){
        this.getDetail();
    },
    components:{
        comRichtext,
    },
    methods:{
        getDetail(){
            this.breadTitle=this.$route.query.type;
            if(this.breadTitle=='重要通知'){
                this.breadTo={ path: '/homeList',query:{type:this.breadTitle} };
                var body={
                    id:this.$route.query.id,
                };
                this.get(this.api.getImportNotice,body).then(res=>{
                    this.detail=res.data;
                }).catch();
            }else if(this.breadTitle=='最新资讯'){
                this.breadTo={ path: '/homeList',query:{type:this.breadTitle} };
                var body={
                    id:this.$route.query.id,
                };
                this.get(this.api.getNewsInfo,body).then(res=>{
                    this.detail=res.data;
                }).catch();
            }else if(this.breadTitle=='今日头条'){
                this.breadTo={ path: '/homeList',query:{type:this.breadTitle} };
                var body={
                    id:this.$route.query.id,
                };
                this.get(this.api.getTopDetail,body).then(res=>{
                    this.detail=res.data;
                    this.detail.createDate=this.detail.modifyDate;
                }).catch();
            }else if(this.breadTitle=='示范应用'){
                this.breadTo={path:'/demoApplication',query:{type:this.breadTitle}};
                var body={
                    id:this.$route.query.id,
                };
                this.get(this.api.getDemoStrationDetail,body).then(res=>{
                    this.detail=res.data;
                    this.detail.createDate=this.detail.modifyDate;
                }).catch();
            }else if(this.breadTitle=='示范产品'){
                this.breadTo={path:'/demoApplication',query:{type:this.breadTitle}};
                var body={
                    id:this.$route.query.id,
                };
                this.get(this.api.getDemoPrductDetail,body).then(res=>{
                    this.detail=res.data;
                    this.detail.createDate=this.detail.modifyDate;
                }).catch();
            }else if(this.breadTitle=='搜索'){
                var item=this.$route.query.item;
                this.detail.infoTitle=item.title;
                this.detail.createDate=item.publishDate;
                this.detail.fgr=item.publishPerson;
                this.detail.fgnr=item.htmlContent;
                // this.detail.infoTitle=item.title;

                // var body={
                //     id:'',
                // };
                // this.get(this.api.getDemoPrductDetail,body).then(res=>{
                //     this.detail=res.data;
                //     const regex = new RegExp('<img', 'gi')
                //     this.detail.fgnr = this.detail.fgnr.replace(regex, `<img style="max-width: 100%; height: auto"`);
                //     this.detail.createDate=this.detail.modifyDate;
                // }).catch();
            }
            

        }
    }
}